<template>
    <site-layout>
        <template>
            <div align="center">
                <img src="../assets/img/logo.png" class="site-logo container" alt=""/>

                <div class="has-text-white">
                    <b>Enter a new password</b><br/>
                    You need at least 8 characters. Ideally, include letters and numbers.
                </div><br/>
            </div>

            <base-backend-errors :data="reset_password.error"/>

            <base-input
                v-model="form.password"
                name="password"
                icon="fas fa-lock"
                type="password"
                validate="required"
                placeholder="New Password"/>

            <base-button
                @click="submit"
                :loading="reset_password.loading"
                class="is-success is-fullwidth"
                icon="fas fa-check"
                text="Reset my password"/>
        </template>

        <base-button
            :to="{name: 'signin'}"
            class="is-primary is-fullwidth"
            icon="fas fa-arrow-left"
            text="Back to sign in"/>
    </site-layout>
</template>

<script>
import { mapState } from 'vuex';
import SiteLayout from '../components/layouts/SiteLayout.vue';

export default {
    name: 'RestPassword',
    components: { SiteLayout },
    data() {
        return { form: { password: null } };
    },
    computed: {
        ...mapState('reset_password', ['reset_password']),
    },
    methods: {
        submit() {
            this.$validator.validate().then((result) => {
                if (!result) return null;

                return this.$store.dispatch('reset_password/reset_password', {
                    password: this.form.password,
                    key: this.$route.params.code,
                }).then(() => {
                    this.$router.push({ name: 'signin', query: { reset: null } });
                });
            });
        },
    },
};
</script>
